<template>
  <swiper-container
    ref="swiper"
    :initial-slide="index"
    :allow-touch-move="allowTouchMove"
    @swiperslidechange="onSlideChange"
  >
    <slot />
  </swiper-container>
</template>

<script setup lang="ts">
import type Swiper from 'swiper'
import { useTemplateRef, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    index: number
    allowTouchMove?: boolean
  }>(),
  {
    allowTouchMove: true
  }
)

const emit = defineEmits<{
  slideChange: [index: number]
}>()

const swiper = useTemplateRef<HTMLElement & { swiper: Swiper }>('swiper')

function onSlideChange(event: CustomEvent) {
  emit('slideChange', event.detail[0].activeIndex)
}

watch(
  () => props.index,
  index => {
    swiper.value?.swiper.slideTo(index)
  }
)
</script>
